// src/index.ts
import { $$TARGET, ReadType } from "@ballpark/realtime-crdt";
import { createAtom } from "mobx";
import { YArrayEvent, YMapEvent } from "yjs";
var $crdtMobx = Symbol("crdt mobx");
var proxyOptions = {
  defaultCtx: {},
  onCreate: ({ item, path, ctx }) => {
    const keysAtom = createAtom(pathToString(path, "__keys"));
    ctx.keysAtom = keysAtom;
    if (Array.isArray(item)) {
      const selfAtom = createAtom(pathToString(path));
      ctx.selfAtom = selfAtom;
    }
    ctx.atoms = /* @__PURE__ */ new Map();
    const yObject = item[$$TARGET];
    yObject == null ? void 0 : yObject.observe((event) => {
      var _a, _b, _c;
      keysAtom.reportChanged();
      if (event instanceof YMapEvent) {
        event.keys.forEach(({ action }, key) => {
          var _a2, _b2;
          const atom = (_a2 = ctx.atoms) == null ? void 0 : _a2.get(String(key));
          if (action === "delete") {
            (_b2 = ctx.atoms) == null ? void 0 : _b2.delete(String(key));
          }
          atom == null ? void 0 : atom.reportChanged();
        });
        event.changes.deleted.forEach((_, key) => {
          var _a2;
          (_a2 = ctx.atoms) == null ? void 0 : _a2.delete(String(key));
        });
        return;
      }
      if (event instanceof YArrayEvent) {
        const lengthOffset = event.changes.added.size - event.changes.deleted.size;
        if (lengthOffset !== 0) {
          (_b = (_a = ctx.atoms) == null ? void 0 : _a.get("length")) == null ? void 0 : _b.reportChanged();
        }
        if (!isPush(event.target.length - lengthOffset, event.delta)) {
          (_c = ctx.selfAtom) == null ? void 0 : _c.reportChanged();
        }
      }
    });
  },
  // This only captures reads from the proxy, if you read directly from YJS it won't know about it
  onRead: ({ ctx, item, type, key, path }) => {
    var _a, _b, _c, _d, _e;
    const stringKey = String(key);
    if (type === ReadType.KEYS) {
      (_a = ctx.keysAtom) == null ? void 0 : _a.reportObserved();
      return;
    }
    if (key !== "length" && Array.isArray(item)) {
      (_b = ctx.selfAtom) == null ? void 0 : _b.reportObserved();
      return;
    }
    const atom = (_d = (_c = ctx.atoms) == null ? void 0 : _c.get(stringKey)) != null ? _d : createAtom(pathToString(path, key));
    atom.reportObserved();
    (_e = ctx.atoms) == null ? void 0 : _e.set(stringKey, atom);
  }
};
function pathToString(path, key) {
  if (path.length === 0) {
    return key === void 0 ? "" : String(key);
  }
  const stringPath = path.join(".");
  return key === void 0 ? stringPath : `${stringPath}.${key}`;
}
function isPush(length, delta) {
  if (!delta.length)
    return true;
  if ("retain" in delta[0] && delta[0].retain === length)
    return true;
  return false;
}
export {
  $crdtMobx,
  proxyOptions
};
